var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.83398,
    cy: 5,
    r: 1.75,
    stroke: "#6D81A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20898 12.5C3.20898 10.4953 4.82414 8.875 6.81055 8.875C7.59727 8.875 8.32575 9.12915 8.91873 9.56068C9.0272 9.63962 9.1562 9.6875 9.29036 9.6875C9.77103 9.6875 10.0201 9.15104 9.64219 8.85405C8.86173 8.24074 7.87905 7.875 6.81055 7.875C4.26649 7.875 2.20898 9.94837 2.20898 12.5V12.875C2.20898 13.1511 2.43284 13.375 2.70898 13.375C2.98513 13.375 3.20898 13.1511 3.20898 12.875V12.5Z",
    fill: "#6D81A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.709 13.625L11.709 9.125",
    stroke: "#6D81A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9121 11.375L9.41211 11.375",
    stroke: "#6D81A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndUser);
export default __webpack_public_path__ + "static/media/endUser.dd15ac630c768c3fdcb4670bb9e38bb0.svg";
export { ForwardRef as ReactComponent };